module.exports = __webpack_public_path__ + "static/media/jcb-logo.3fc41615.png";